import { render, staticRenderFns } from "./ManualPreviewCard.vue?vue&type=template&id=b282f980"
import script from "./ManualPreviewCard.vue?vue&type=script&lang=js"
export * from "./ManualPreviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports